import {Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'lib-faq-container',
    templateUrl: './faq-container.component.html',
    styleUrls: ['./faq-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FaqContainerComponent implements OnInit {

  @Output() hideMe = new EventEmitter();
  @Output() closeMe = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
  }

}
